import { EmptyImage } from 'app/components/commons/Images/EmptyImage/EmptyImage';
import { SingleImage } from 'app/components/commons/Images/SingleImage/SingleImage';
import tableStyles from 'app/components/pages/Hotels/Form/PackagesRoomsAmenities/PackagesRoomsAmenities.module.scss';
import { EntityRow } from 'app/components/pages/Hotels/Form/PackagesRoomsAmenities/_components/entity/EntityRow';
import { EntitySection } from 'app/components/pages/Hotels/Form/PackagesRoomsAmenities/_components/entity/EntitySection';
import { EntityTable } from 'app/components/pages/Hotels/Form/PackagesRoomsAmenities/_components/entity/EntityTable';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';

import styles from './SpaceLinkedExperiences.module.scss';

type Props = {
  spaceId: number;
  experiences: ExperienceResponse[];
  categoryNameById: Record<number, string>;
};

const COVER_IMAGE_SIZE = 40;

export const SpaceLinkedExperiences = ({
  spaceId,
  experiences,
  categoryNameById,
}: Props) => {
  const linkedExperiences = experiences.filter((experience) =>
    (experience.spaceIds ?? []).includes(spaceId)
  );

  return (
    <div className={`${styles.container} ${tableStyles.mainContent}`}>
      <div className={tableStyles.content}>
        <EntityTable
          bordered={false}
          sections={[
            {
              key: `space-${spaceId}-experiences`,
              label: 'Activities linked to this space',
              items: linkedExperiences,
            },
          ]}
          renderSection={(section) => (
            <EntitySection
              key={section.key}
              section={section}
              renderItem={(experience) => (
                <EntityRow
                  key={experience.id}
                  tableType="activity"
                  config={{
                    id: experience.id,
                    cover: experience.coverPicture ? (
                      <SingleImage
                        image={experience.coverPicture}
                        width={COVER_IMAGE_SIZE}
                        height={COVER_IMAGE_SIZE}
                      />
                    ) : (
                      <EmptyImage
                        width={COVER_IMAGE_SIZE}
                        height={COVER_IMAGE_SIZE}
                      />
                    ),
                    primaryLabel:
                      categoryNameById[experience.categoryId] ??
                      `Activity #${experience.id}`,
                    status: experience.status,
                    redirectPath: `/activities/${experience.id}`,
                    actions: [],
                  }}
                />
              )}
              emptyLabel="No activities"
              emptyDescription="No activity is linked to this space yet."
            />
          )}
        />
      </div>
    </div>
  );
};
